import { useQuery } from '@tanstack/react-query';
import { getWorkflowsByLabel } from '@/services/composer-dashboard/get-workflows-by-label';
import { WorkflowsByLabelResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetWorkflowsByLabel = (options?: { enabled?: boolean }) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<WorkflowsByLabelResponse, Error>({
    queryKey: ['composer-workflows-by-label', orgId],
    queryFn: () => getWorkflowsByLabel(orgId!),
    enabled: !!orgId && (options?.enabled ?? true),
    retry: 1,
    staleTime: 60000,
  });
};
